// extracted by mini-css-extract-plugin
module.exports = {"tableTitle":"SupportPageView_tableTitle__2j3_j"};